/**
 * Régua única para apresentar dado de tendência do Google.
 *
 * Existia uma cópia em Intelligence.tsx e outra em Board.tsx, erradas de formas
 * diferentes — e é assim que o mesmo número aparece de dois jeitos em duas telas
 * do mesmo produto.
 */

/**
 * Escreve o volume de busca com a gramática do próprio Google.
 *
 * O número que o provedor entrega é o **piso de uma faixa**, nunca uma medição:
 * na interface do Google lê-se "1 M+", "200 mil+", "5 mil+", "500+". Escrever
 * "500" afirma um número que ele nunca afirmou — o real pode ser 900. Por isso
 * o mais nunca sai, e nada é arredondado para cima.
 */
export function volumeDeBusca(v: number | null | undefined): string {
  if (v === null || v === undefined) return '—'; // não sabemos
  if (v === 0) return '0'; // medimos zero — que é outra coisa
  if (v >= 1_000_000) return `${Math.floor(v / 1_000_000)} M+`;
  if (v >= 1_000) return `${Math.floor(v / 1_000)} mil+`;
  return `${v}+`;
}
